import { render } from "./CourseRating.vue?vue&type=template&id=ed870f3c&scoped=true"
import script from "./CourseRating.vue?vue&type=script&lang=js"
export * from "./CourseRating.vue?vue&type=script&lang=js"

import "./CourseRating.vue?vue&type=style&index=0&id=ed870f3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed870f3c"]])

export default __exports__